/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Coaching_LineInputs */

const en_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line`)
};

const es_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea`)
};

const fr_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich`)
};

const ja_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチングの種類`)
};

const zh_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指导方向`)
};

const ar_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجال`)
};

const id_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lini`)
};

const it_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area di Specializzazione`)
};

const ru_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Направление коучинга`)
};

const pt_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha de Coaching`)
};

const ko_field_coaching_line = /** @type {(inputs: Field_Coaching_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분야`)
};

/**
* | output |
* | --- |
* | "Line" |
*
* @param {Field_Coaching_LineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_coaching_line = /** @type {((inputs?: Field_Coaching_LineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Coaching_LineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_coaching_line(inputs)
	if (locale === "es") return es_field_coaching_line(inputs)
	if (locale === "fr") return fr_field_coaching_line(inputs)
	if (locale === "de") return de_field_coaching_line(inputs)
	if (locale === "ja") return ja_field_coaching_line(inputs)
	if (locale === "zh") return zh_field_coaching_line(inputs)
	if (locale === "ar") return ar_field_coaching_line(inputs)
	if (locale === "id") return id_field_coaching_line(inputs)
	if (locale === "it") return it_field_coaching_line(inputs)
	if (locale === "ru") return ru_field_coaching_line(inputs)
	if (locale === "pt") return pt_field_coaching_line(inputs)
	return ko_field_coaching_line(inputs)
});